<template>
  <div id="personalinformation">
    <div class="v_box1">
      <div class="b_banxin">
        <ul class="navbox flex">
          <li class="navboxliico">
            <img src="@/assets/img/shouye.png" alt class="v_ico" />
            <span style="display: inline-block;">首页</span>
          </li>
          <li class="navboxliico">个人中心</li>
          <span class="navboxli" v-show="tabnum == 1">通知公告</span>
          <span class="navboxli" v-show="tabnum == 2">站内信</span>
        </ul>
      </div>
    </div>
    <div class="personalaccount_content">
      <div class="personalaccount_content_left">
        <div class="personalaccount_content_left_item">
          <div class="personalaccount_content_left_item_head">资讯中心</div>
          <div class="personalaccount_content_left_item_content">
            <div
              :class="{
                personalaccount_content_left_item_content_box: true,
                select_box: tabnum == 1
              }"
              @click="tablist(1)"
            >
              通知公告
            </div>
            <div
              :class="{
                personalaccount_content_left_item_content_box: true,
                select_box: tabnum == 2
              }"
              @click="tablist(2)"
              v-if="codes"
            >
              站内信
            </div>
          </div>
        </div>
      </div>
      <div class="personalaccount_content_right" v-show="tabnum == 1">
        <div class="personalaccount_content_right_head">
          <img src="../../../assets/img/personalhome/lbico3.png" />通知公告
        </div>
        <div v-if="getnewallnumnull">
          <div class="personalaccount_content_right_center">
            <div
              class="personalaccount_content_right_centerlist"
              @click="toinner(tabnum, item)"
              v-for="(item, index) in noticelist"
              :key="index"
            >
              <div class="personalaccount_content_right_centerlistleft">
                <img src="../../../../public/img/lbico2.png" />
                <span>{{ item.title }}</span>
              </div>
              <div class="personalaccount_content_right_centerlistrig">
                {{ item.add_time }}
              </div>
            </div>
          </div>
          <div class="personalaccount_content_right_btn">
            <!-- <span
              class="personalaccount_content_right_btn_son"
              @click="getnewall(getnewallnums - 1)"
              >上一页</span
            >
            <span class="personalaccount_content_right_btn_son1"
              >{{ getnewallnums }}/{{ getnewallnum }}</span
            >
            <span
              class="personalaccount_content_right_btn_son"
              @click="getnewall(getnewallnums + 1)"
              >下一页</span
            > -->
            

            <el-pagination
              background
              layout="prev, pager, next,slot"
              :page-count="getnewallnum"
              @prev-click="getnewall(getnewallnums - 1)"
              @next-click="getnewall(getnewallnums + 1)"
              @current-change="handleCurrentChange"
              hide-on-single-page
            >
              <span class="allspan">总计:&nbsp;&nbsp;&nbsp;{{getnewallnum}}页</span>
            </el-pagination>
          </div>
        </div>
        <div class="null" v-else>
          <img src="@/assets/img/iconull1.png" />
        </div>
      </div>
      <div class="personalaccount_content_right" v-show="tabnum == 2">
        <div class="personalaccount_content_right_head">
          <img src="../../../assets/img/personalhome/email3.png" />站内信
        </div>
        <div v-if="getnewal2numnull">
          <div class="personalaccount_content_right_center">
            <div
              :class="{
                personalaccount_content_right_centerlist: true,
                personalaccount_content_right_centerlistover: item.status == '1'
              }"
              @click="toinner(tabnum, item)"
              v-for="(item, index) in mail"
              :key="index"
            >
              <div class="personalaccount_content_right_centerlistleft">
                <img
                  src="../../../../public/img/91f04b76454322388129203f4be54fd.png"
                  v-if="item.status == '1'"
                />
                <img src="../../../../public/img/email2.png" v-else />

                <span>{{ item.title }}</span>
              </div>
              <div class="personalaccount_content_right_centerlistrig">
                {{ item.add_time }}
              </div>
            </div>
          </div>
          <div class="personalaccount_content_right_btn">
            <!-- <span
              class="personalaccount_content_right_btn_son"
              @click="getnewall2(getnewall2nums - 1)"
              >上一页</span
            >
            <span class="personalaccount_content_right_btn_son1"
              >{{ getnewall2nums }}/{{ getnewall2num }}</span
            >
            <span
              class="personalaccount_content_right_btn_son"
              @click="getnewall2(getnewall2nums + 1)"
              >下一页</span
            > -->
            <el-pagination
              background
              layout="prev, pager, next,slot"
              :page-count="getnewall2num"
              @prev-click="getnewall2(getnewall2nums - 1)"
              @next-click="getnewall2(getnewall2 + 1)"
              @current-change="handleCurrentChanga"
              hide-on-single-page
            >
              <span class="allspan">总计:&nbsp;&nbsp;&nbsp;{{getnewall2num}}页</span>
            </el-pagination>
          </div>
        </div>
        <div class="null" v-else>
          <img src="@/assets/img/iconull2.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import DateSelect from "@/components/DateSelect";
export default {
  name: "personalOrder",

  components: { DateSelect },
  data() {
    return {
      fixedkey: false,
      tableBlock: 1,
      tabnum: 1,
      noticelist: [],
      mail: [],
      codes: false,
      getnewallnum: 0, //公告总页数
      getnewallnums: 1, //公告当前页数,
      getnewallnumnull: true, //true 有数据  false无数据
      getnewall2num: 0, //站内信总页数
      getnewall2nums: 1, //站内信当前页数
      getnewal2numnull: true //true 有数据  false无数据,
    };
  },

  mounted() {
    let that = this;
    window.addEventListener("scroll", this.handleScroll);

    if (that.$storage.get("user_data") != null) {
      this.tabnum = this.$route.query.id;
      that.codes = true;
    } else {
      that.codes = false;
      this.tabnum = 1;
    }
    that.getnewall();
    that.getnewall2();
  },
  watch: {
    $route() {
      if (this.$route.query.id == "1") {
        this.getnewall();
        this.tabnum = 1;
      } else if (this.$route.query.id == "2") {
        this.getnewall2();
        this.tabnum = 2;
      }
    }
  },

  methods: {
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      console.log();
      if (scrollTop >= 300) {
        this.fixedkey = true;
      } else {
        this.fixedkey = false;
      }
    },
    dateChange(obj) {
      console.log(obj.year + "-" + obj.month + "-" + obj.day);
    },
    btnClick(index) {
      let that = this;
      that.tableBlock = index;
    },
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background: #eeeeee;font-size:18px;color:#333333;text-align:center;border-right:1px solid #dddddd;font-weight:500";
      } else {
        return "";
      }
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 2) {
        return "text-align:center;font-size:16px;color:#dc1e33;";
      } else {
        return "text-align:center;font-size:16px;color:#333333;";
      }
    },
    goFukuan(index, row) {
      let that = this;
      console.log(index, row);
      if (that.tableBlock == 4) {
        that.$router.push({ path: "/personalevaluation", query: { id: "1" } });
      } else if (that.tableBlock == 5) {
        that.$router.push({ path: "/personalAftersale", query: { id: "1" } });
      } else {
        that.$router.push({ path: "/personalObligation", query: { id: "1" } });
      }
    },
    tablist(index) {
      let that = this;
      that.tabnum = index;
    },
    toinner(id, index) {
      let that = this;
      if (that.tabnum == "1") {
        that.$router.push({
          path: "/personalinformation",
          query: { id: "1", bookid: index.id }
        });
      } else if (that.tabnum == "2") {
        that.$router.push({
          path: "/personalinformation",
          query: { id: "2", bookid: index.id }
        });
      } else {
      }
    },
    //获取公告列表
    getnewall(page = "1") {
      let that = this;
      axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
        },
        url: that.$publicUrl.http1 + that.$publicUrl.getnewall,
        data: qs.stringify({
          sign: "2",
          page: page
        })
      })
        .then(function(response) {
          let data = response.data;
          if (data.stateCode == 10000) {
            that.noticelist = data.data;
            // that.noticelist = [];
            if (that.noticelist.length == "0") {
               that.getnewallnumnull = false;
            }
            console.log(data.data);
            that.getnewallnum = data.count; //公告列表
            that.getnewallnums = Number(page);
          } else {
            that.$message({
              message: data.msg,
              type: "warning"
            });
          }
        })
        .catch(function(error) {});
    },
    //获取站内信列表
    getnewall2(page = "1") {
      let that = this;
      axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
        },
        url: that.$publicUrl.http1 + that.$publicUrl.getnewall,
        data: qs.stringify({
          sign: "1",
          page: page,
          user_id: that.$storage.get("user_data").user_id
        })
      })
        .then(function(response) {
          let data = response.data;
          if (data.stateCode == 10000) {
            console.log("获取站内信列表");
            console.log(data);
            that.mail = data.data; //站内信列表
            // that.mail =[]; //站内信列表

            if (that.mail.length == "0") {
              that.getnewal2numnull = false;
            }
            that.getnewall2num = data.count;
            that.getnewall2nums = Number(page);
          } else {
            that.$message({
              message: data.msg,
              type: "warning"
            });
          }
        })
        .catch(function(error) {});
    },
    handleCurrentChange(val) {
      let that = this;

      that.getnewall(val);
    },
    handleCurrentChanga(val) {
      let that = this;
      that.getnewall2(val);
    }
  }
};
</script>

<style scoped="scoped">
#personalinformation {
  background-color: #f6f6f6;
  padding-bottom: 20px;
}
#personalOrder {
  width: 100%;
  background-color: #f6f6f6;
  padding-top: 20px;
  padding-bottom: 20px;
}

.personalaccount_content {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-wrap: nowrap;
  align-items: self-start;
}

.personalaccount_content_left {
  width: 220px;
  text-align: center;
  background: #ffffff;
}

.personalaccount_content_left_item_head {
  width: 100%;
  height: 50px;
  line-height: 50px;
  background: #dddddd;
  color: #333333;
  font-size: 18px;
  font-weight: 550;
}

.personalaccount_content_left_item_content {
  width: 100%;
}
.null {
  width: 100%;
  box-sizing: border-box;
  padding: 140px;
}
.allspan{
    margin: 0 5px;
    color: #606266;
    min-width: 30px;
    border-radius: 2px;
    padding:0 20px;
}
.null img {
  display: block;
  max-width: 100%;
  margin: 0 auto;
}
.personalaccount_content_left_item_content_box {
  font-size: 16px;
  color: #333333;
  width: 100%;
  height: 40px;
  margin-top: 10px;
  line-height: 40px;
  cursor: pointer;
}
.select_box {
  background: #dc1e33;
  color: #ffffff;
}
.personalaccount_content_left_item_content_box span {
  color: #dc1e33;
}

.personalaccount_content_right {
  width: 920px;
  margin-left: 20px;
  background: #ffffff;
  -webkit-box-shadow: 0 1px 3px #ccc;
  box-shadow: 0 1px 3px #ccc;
}

.personalaccount_content_right_head {
  height: 50px;
  line-height: 50px;
  box-sizing: border-box;
  padding-left: 20px;
  padding-right: 20px;
  width: 100%;
  color: #333333;
  font-size: 18px;

  border-bottom: 1px solid #dddddd;
}
.personalaccount_content_right_head img {
  display: inline-block;
  margin-right: 8px;
  width: 23px;
}
.order_head {
  width: 100%;
  height: 50px;
  line-height: 50px;
  font-size: 16px;
  color: #333333;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-around;
  background: white;
}

.order_head_item span {
  color: #dc1e33;
}
.order_content {
  margin-top: 20px;
}
.order_head_item {
  color: #333333;
  cursor: pointer;
}
.order_head_item_click {
  color: #dc1e33;
}
.v_box1 {
  width: 100%;
  background-color: #f6f6f6;
  box-sizing: border-box;
  padding: 20px 0;
}

.navbox {
  height: 20px;
  padding: 0 0px;
  box-sizing: border-box;
}

.navbox li {
  display: inline-block;
  height: 20px;
  font-size: 16px;
  padding: 0 5px;
  vertical-align: top;
  margin-right: 20px;
  position: relative;
}

.navboxli li span {
  display: inline-block;
  height: 20px;
  font-size: 16px;
  vertical-align: top;
}

.navbox span {
  display: none;
}

.navbox .navboxli {
  display: inline-block;
  height: 20px;
  font-size: 16px;
  padding: 0 5px;
  vertical-align: top;
  margin-right: 20px;
  position: relative;
}

.navboxliico:after {
  content: "\e6e0";
  font-size: 15px;
  position: absolute;
  top: 58%;
  right: -16px;
  transform: translateY(-50%);
  color: #585858;
  font-family: element-icons !important;
  font-style: normal;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  vertical-align: baseline;
  display: inline-block;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.v_ico {
  width: 19px;
  height: 19px;
  display: inline-block;
  object-fit: scale-down;
  vertical-align: top;
  margin-right: 10px;
}
.personalaccount_content_right_center {
  width: 100%;
  box-sizing: border-box;
  padding: 20px 0;
}
.personalaccount_content_right_centerlist {
  font-size: 16px;
  color: #333333;
  line-height: 30px;
  cursor: pointer;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  align-items: flex-start;
  box-sizing: border-box;
  padding: 10px 20px;
}
.personalaccount_content_right_centerlistleft {
  width: 720px;
}
.personalaccount_content_right_centerlistright {
  width: 200px;
}
.personalaccount_content_right_centerlistover {
  color: #999999;
}
.personalaccount_content_right_centerlist:hover {
  background-color: #dddddd;
}
.personalaccount_content_right_centerlist img {
  display: inline-block;
  width: 19px;
  vertical-align: middle;
  margin-right: 8px;
}
.personalaccount_content_right_centerlist span {
  display: inline-block;
  max-width: calc(100%- 20px);
  line-height: 30px;
  position: relative;
}
/* .personalaccount_content_right_centerlist span::after{
  content:'未读';
  position: absolute;
  top:-2px;
  right: -25px;
  z-index: 10;
  font-size: 10px;
  height: 14px;
  line-height: 14px;
  padding: 0 5px;
  box-sizing: border-box;
  color:red;
}
.personalaccount_content_right_centerlistover span::after{
  content:'已读';
  position: absolute;
  top:-2px;
  right: -25px;
  z-index: 10;
  font-size: 10px;
  height: 14px;
  line-height: 14px;
  padding: 0 5px;
  box-sizing: border-box;
  color: #999999;
} */
.personalaccount_content_right_btn {
  width: 100%;
  height: 40px;
  margin: 20px 0;
  text-align: center;
}
.personalaccount_content_right_btn_son {
  height: 40px;
  display: inline-block; 
  font-size: 16px;
  line-height: 40px;
  margin: 0 20px;
  border-radius: 5px;
  cursor: pointer;
  border: 1px solid #dddddd;
}
.personalaccount_content_right_btn_son1 {
  height: 40px;
  display: inline-block;
  padding: 0 15px;
  font-size: 16px;
  line-height: 40px;
  margin: 0 20px;
}
</style>
